import { useContext } from 'react'

import {
  Box, Columns, DashboardModule, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'

import { AttachmentTag } from '@models/types'

import PagePreview from './components/PagePreview'
import Tag from './components/Tag'

const MODAL_KEY = 'ViewRequestedChangesModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  requestOptions?: object,
  showModal: boolean,
}

const ViewRequestedChangesModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData?.[MODAL_KEY] ?? {}
  const { attachment = {} } = modalPayload

  const attachmentPayload = useAttachment(attachment)
  const {
    callbacks: {
      toggleAttachmentResolution: toggleResolutionFn,
    },
    tags,
  } = attachmentPayload

  return (
    <SidebarModal callbacks={callbacks} modalKey={MODAL_KEY} showModal={showModal} size="fullscreen">
      <SidebarModal.Header callbacks={callbacks} title="View" titleSecondLine="Requested Changes" />

      <SidebarModal.Content boxProps={{ backgroundColor: 'backgroundColor' }} hasFooter={false}>
        <Columns flexDirection={['column-reverse', 'column-reverse', 'row']}>
          <Columns.Main>
            <PagePreview attachment={attachment} tags={tags} />
          </Columns.Main>

          <Columns.Sidebar>
            <DashboardModule title="Comments">
              <Box flexDirection="column">
                {tags.map((tag: AttachmentTag, index: number) => (
                  <Tag
                    callbacks={{
                      resolveTag: () => toggleResolutionFn(tag),
                    }}
                    index={index}
                    last={tags.length === index + 1}
                    key={tag.id}
                    tag={tag}
                  />
                ))}
              </Box>
            </DashboardModule>
          </Columns.Sidebar>
        </Columns>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ViewRequestedChangesModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
